import { Brands } from '../constants.js';

var iconsDefaultValues = {
  Brand: Brands.DoorDash,
  shouldAdjustSmallSizesWhitespace: false
};

export { iconsDefaultValues };
